// components/AnimatedTitle.jsx
interface TitleProps {
  text: string;
  className?: string;
}

export default function AnimatedTitle({ text, className }: TitleProps) {
  return (
    <h2 className={className}>
      {text.split(" ").map((word, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: static text, never reordered
        <span key={word + i} className="inline-block">
          {word.split("").map((char, j) => (
            <span
              // biome-ignore lint/suspicious/noArrayIndexKey: static text, never reordered
              key={j}
              className="hover:scale-110 hover:rotate-3 inline-block transition-transform"
            >
              {char}
            </span>
          ))}
          {"\u00A0"}
        </span>
      ))}
    </h2>
  );
}
